/** Only a CRM session check can expire the workspace; upstream 401s are not session facts. */
const listeners = new Set<() => void>();
let generation = 0;
let pending: { generation: number; promise: Promise<void> } | null = null;
export function subscribeSessionExpiry(listener: () => void): () => void {
  generation++;
  listeners.add(listener);
  return () => { listeners.delete(listener); generation++; };
}
async function checkSessionResponse(response: Response, path: string, requestGeneration: number): Promise<void> {
  if (requestGeneration !== generation || response.status !== 401 || path.startsWith('/auth/') || listeners.size === 0) return;
  const current = generation;
  if (pending?.generation === current) return pending.promise;
  const promise = (async () => {
    try {
      // Direct fetch intentionally bypasses request(), so an expired probe cannot recurse.
      const session = await fetch('/api/v1/auth/me', { credentials: 'include', cache: 'no-store' });
      if (session.status === 401 && generation === current) {
        for (const listener of [...listeners]) listener();
      }
    } catch { /* Network failure is not proof that the session expired. */ }
  })();
  pending = { generation: current, promise };
  try { await promise; } finally { if (pending?.promise === promise) pending = null; }
}

export async function sessionFetch(path: string, init: RequestInit): Promise<Response> {
  const requestGeneration = generation;
  const response = await fetch(path, init);
  await checkSessionResponse(response, path.replace(/^\/api\/v1/, ''), requestGeneration);
  return response;
}
